import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { filterByFeatured } from "../redux/filter/actions";
import loadBooks from "../redux/middlewares/thunk/books/retrieveBooksMiddleware";
import { searchBooks } from "../redux/search/actions";
import Book from "./Book";

function BookContainer() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadBooks());
  }, [dispatch]);

  const Allbooks = useSelector((state) => state.books);
  const books = useSelector((state) => state.filter);
  const searchedBooks = useSelector((state) => state.search);
  const [filter, setFilter] = useState("All");

  function handleFilter(featureType) {
    setFilter(featureType);
    // dispatch(filterByFeatured(Allbooks, featureType));
  }

  //Update the books if only DB or filter changes
  useEffect(() => {
    if (searchBooks?.length === 0) {
      dispatch(filterByFeatured(Allbooks, filter));
    } else {
      dispatch(filterByFeatured(searchedBooks, filter));
    }
  }, [Allbooks, filter, searchedBooks, dispatch]);

  return (
    <div className="order-2 xl:-order-1">
      <div className="flex items-center justify-between mb-12">
        <h4 className="mt-2 text-xl font-bold">Book List</h4>

        <div className="flex items-center space-x-4">
          <button
            className={`filter-btn ${filter === "All" && "active-filter"}`}
            id="lws-filterAll"
            onClick={() => handleFilter("All")}
          >
            All
          </button>
          <button
            className={`filter-btn ${filter === "Featured" && "active-filter"}`}
            id="lws-filterFeatured"
            onClick={() => handleFilter("Featured")}
          >
            Featured
          </button>
        </div>
      </div>
      <div className="lws-bookContainer">
        {books?.length > 0
          ? books.map((book) => {
              return <Book key={book.id} book={book} />;
            })
          : "No Book Added yet"}
      </div>
    </div>
  );
}

export default BookContainer;
